import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const buttonTypes = {
  EDIT: {
    className: 'configurator__button-edit',
    iconClassName: 'icon-pencil-outline',
  },
  REMOVE: {
    className: 'configurator__button-remove',
    iconClassName: 'icon-trash',
  },
};

// If true, centers selection buttons if there is only one of them
const SELECTION_BUTTONS_ALIGN = false;

export default class SelectionBorder extends React.Component {
  constructor(props) {
    super(props);

    this.clickSelectionHandler = this.clickSelectionHandler.bind(this);
    this.clickEditButtonHandler = this.clickEditButtonHandler.bind(this);
    this.clickRemoveButtonHandler = this.clickRemoveButtonHandler.bind(this);
  }

  // Event handlers

  clickSelectionHandler() {
    if (this.props.onClickSelection) {
      this.props.onClickSelection(this.props.data);
    }
  }

  clickEditButtonHandler() {
    if (this.props.onClickEdit) {
      this.props.onClickEdit(this.props.data);
    }
  }

  clickRemoveButtonHandler() {
    if (this.props.onClickRemove) {
      this.props.onClickRemove(this.props.data);
    }
  }

  // Render methods

  renderButton(type, handler) {
    const iconClassName = type ? type.iconClassName : null;
    const buttonClassName = type ? type.className : null;

    const align = SELECTION_BUTTONS_ALIGN ? 'config-selection-button-aligned' : null;

    const className = classnames('configurator__button', buttonClassName, align);
    const iconClass = classnames('configurator__button-icon', iconClassName);

    return (
      <div className={className} onTouchStart={handler} onMouseDown={handler} role="button">
        <span className={iconClass} />
      </div>
    );
  }

  render() {
    let UI = null;
    const editable = this.props.editable;
    const removable = this.props.removable;

    if (removable || editable) {
      // Render delete and / or edit buttons
      const editButton = editable ? this.renderButton(buttonTypes.EDIT, this.clickEditButtonHandler) : null;
      const removeButton = removable ? this.renderButton(buttonTypes.REMOVE, this.clickRemoveButtonHandler) : null;
      let numButtons = 0;

      if (editButton) {
        numButtons += 1;
      }
      if (removeButton) {
        numButtons += 1;
      }

      const uiClassNameBase = 'configurator__component-ui-container';
      const modifier = numButtons === 1 ? '--1-component' : `--${numButtons}-components`;
      const uiClassName = classnames(uiClassNameBase, `${uiClassNameBase}${modifier}`);

      UI = (
        <div className={uiClassName}>
          {editButton}
          {removeButton}
        </div>
      );
    }
    const x = Math.round(this.props.x);
    const y = Math.round(this.props.y);
    const width = Math.round(this.props.width);
    const height = Math.round(this.props.height);

    const overlayStyle = {
      left: `${x}px`,
      top: `${y}px`,
      width: `${width}px`,
      height: `${height}px`,
    };

    const overlayRectStyle = {
      width: `${width}px`,
      height: `${height}px`,
    };

    let clickHandler = null;
    if (this.props.onClickSelection) {
      clickHandler = this.clickSelectionHandler;
    }

    return (
      <div className="configurator__component-overlay" style={overlayStyle}>
        <div className="configurator__component-overlay__rect" style={overlayRectStyle} onClick={clickHandler} role="button">
          {/* 4 small rectangles in each corner */}
          <div className="configurator__component-overlay__corner configurator__component-overlay__corner--top-left" />
          <div className="configurator__component-overlay__corner configurator__component-overlay__corner--top-right" />
          <div className="configurator__component-overlay__corner configurator__component-overlay__corner--bottom-left" />
          <div className="configurator__component-overlay__corner configurator__component-overlay__corner--bottom-right" />
        </div>
        {UI}
      </div>
    );
  }
}

SelectionBorder.propTypes = {
  data: PropTypes.object,

  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,

  editable: PropTypes.bool,
  removable: PropTypes.bool,
  onClickSelection: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickRemove: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/configuration/selection-border.jsx